exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".interchange{text-align:center;padding-top:60px}#permissionSet table{width:100%}#permissionSet table thead tr{background-color:#ccc}#permissionSet table tr{background-color:#fff}#permissionSet table tr.epigraph{background-color:#eee}#permissionSet table td{padding:10px 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/permissions/permissions.css
// module id = 244
// module chunks = 0